module.exports = __webpack_public_path__ + "img/shipment.c44352cf.svg";